import crave from 'app/assets/images/press/crave.svg'
import explore from 'app/assets/images/press/explore.png'
import wiredforadventure from 'app/assets/images/press/wiredforadventure.png'
import yogapluslife from 'app/assets/images/press/yoga+life.png'
import wellbeing from 'app/assets/images/press/wellbeing.webp'
import yogamagazine from 'app/assets/images/press/yogamagazine.png'

export interface PressItem {
  imageProps: {
    src: string
    alt: string
    height: number
  }
  title: string
  link: string
}

export const PressItems: PressItem[] = [
  {
    imageProps: {
      src: wiredforadventure,
      alt: 'wired-for-adventure',
      height: 33,
    },
    title: 'Top 5 destinations for group hiking adventures - and how to organize one',
    link: 'https://www.wiredforadventure.com/top-5-destinations-for-group-hiking-adventures-and-how-to-organise-one/',
  },
  {
    imageProps: {
      src: crave,
      alt: 'crave',
      height: 19,
    },
    title: 'TourHero: How this social travel platform makes your trip pay for itself',
    link: 'https://cravemag.co.uk/tourhero-how-this-social-travel-platform-makes-your-trip-pay-for-itself/',
  },
  {
    imageProps: {
      src: explore,
      alt: 'explore',
      height: 31,
    },
    title: '5 Bucket List Hikes That Are Way Better with a Group',
    link: 'https://explore-mag.com/5-bucket-list-hikes-that-are-way-better-with-a-group/',
  },
]

export const WellnessPressItems: PressItem[] = [
  {
    imageProps: {
      src: yogamagazine,
      alt: 'yoga-love-magazine',
      height: 36,
    },
    title: 'How to organize a yoga retreat: A complete guide for teachers and practitioners',
    link: 'https://yogalovemagazine.com/how-to-organize-a-yoga-retreat-a-complete-guide-for-teachers-and-practitioners/',
  },
  {
    imageProps: {
      src: wellbeing,
      alt: 'wellbeing-magazine',
      height: 24,
    },
    title: '5 signs you’re overdue for a soul-healing wellness retreat',
    link: 'https://wellbeingmagazine.com/5-signs-youre-overdue-for-a-soul-healing-wellness-retreat/',
  },
  {
    imageProps: {
      src: yogapluslife,
      alt: 'yoga-plus-life',
      height: 16,
    },
    title: 'Partner Profile: TourHero',
    link: 'https://yogalifelive.com/partner-profile-tourhero/',
  },
]
